import React, { useState, useEffect } from 'react';
import './LiverWindow.modules.css';

const LiverWindow = ({ img, text }) => {
    const [displayedText, setDisplayedText] = useState(""); // 表示中の文字列
    const [textIndex, setTextIndex] = useState(0); // 現在の文字のインデックス

    useEffect(() => {
        setDisplayedText(""); // 表示文字をリセット
        setTextIndex(0); // インデックスをリセット
    }, [text]); // textが変更されたとき

    useEffect(() => {
        if (text != null) {
            if (textIndex < text.length) {
                const timeoutId = setTimeout(() => {
                    setDisplayedText((prev) => prev + text[textIndex]); // 1文字ずつ追加
                    setTextIndex((prev) => prev + 1); // インデックスを更新
                }, 20); // 文字表示間隔（ミリ秒）
                return () => clearTimeout(timeoutId); // クリーンアップ
            }
        }
    }, [textIndex, text]);

    return (
        <div className="liver_window">
            <img src={img} className="liver_image" alt="キャラクター画像" />
            <div className="talk_window">
                <img src="img/liver_talk_bg.png" className="talk_bg" alt="背景" />
                <div className="talk_text">{displayedText}</div>
            </div>
        </div>
    );
};

export default LiverWindow;
